
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a3e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a3e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lXnmw", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ffc13ae7ce131135$export$6503ec6e8aabbaf; }, function (v) { return $ffc13ae7ce131135$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ffc13ae7ce131135$export$f7ad0328861e2f03; }, function (v) { return $ffc13ae7ce131135$export$f7ad0328861e2f03 = v; });
var $ffc13ae7ce131135$export$6503ec6e8aabbaf;
var $ffc13ae7ce131135$export$f7ad0328861e2f03;
"use strict";
var $ffc13ae7ce131135$var$mapping = new Map();
function $ffc13ae7ce131135$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ffc13ae7ce131135$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ffc13ae7ce131135$var$resolve(id) {
    var resolved = $ffc13ae7ce131135$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ffc13ae7ce131135$export$6503ec6e8aabbaf = $ffc13ae7ce131135$var$register;
$ffc13ae7ce131135$export$f7ad0328861e2f03 = $ffc13ae7ce131135$var$resolve;

});

var $c3626f5adcbad0ba$exports = {};

(parcelRequire("lXnmw")).register(new URL("", import.meta.url).toString(), JSON.parse('["gjHgh","index.2cc05be4.js","eQO7j","Grocery.33f81503.js"]'));


//# sourceMappingURL=index.runtime.3a9dd145.js.map
